/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HorizontalDivider/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function HorizontalDivider({
  children,
  viewPath = "/DesignSystem/HorizontalDivider",
  backgroundColor,
  width = "100%",
  marginTop = 0,
  marginBottom = 0
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let backgroundColorOrdtColorsNeutral200 = backgroundColor ?? dtColorsNeutral200
  return (<React.Fragment
>
<div
  data-testid="HorizontalDivider.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z220Dwg': backgroundColorOrdtColorsNeutral200,'--w-2-Z220Dwg': typeof width === 'number' ? `${width}px` : width,'--mt-3-Z220Dwg': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-4-Z220Dwg': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-block ${styles.Horizontal}`}
/>
{children}
</React.Fragment>)
}